import moment from 'moment'

export default [
  { label: 'Razão social', field: 'razaoSocial', tdClass: 'col-tamanho-cnpj' },
  { label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'col-tamanho-cnpj' },
  {
    label: 'Identificador',
    field: 'idApuracao',
  },
  { label: 'Período apuração', field: 'periodoApuracao' },
  {
    label: 'Valor apurado',
    field: 'valorApurado',
    tdClass: 'col-valores',
    formatter: value => {
      if (!value && value !== 0) return ''
      return `R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
  },
  { label: 'Situação', field: 'situacaoApuracao', type: 'custom' },
  {
    label: 'Consultado em',
    field: 'consultadoEm',
    tdClass: 'col-valores',
    formatter: value => {
      if (!value) return ''
      const m = moment(value, 'DD/MM/YYYY HH:mm')
      return m.isValid() ? m.format('DD/MM/YYYY') : ''
    },
  },
]
